var _defs, _text, _text2, _text3, _text4, _text5, _text6, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallscooterstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1223,
    height: 1454,
    viewBox: "0 0 1223 1454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#a1a0a0;font-size:22px;font-family:DMSans-Regular,DM Sans}.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill:none}.cls-2,.cls-3{stroke:#a1a0a0;stroke-width:2px}.cls-2{stroke-linecap:round;stroke-linejoin:round}.cls-4,.cls-5{stroke:#000}.cls-4{stroke-width:3px}.cls-6,.cls-8{stroke:#707070}.cls-8{fill:#fff}.cls-11,.cls-9{stroke:none}.cls-11{fill:#707070}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "small_scooter_stand",
    "data-name": "small scooter stand",
    transform: "translate(-1821 -2045.5)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_48.80",
    "data-name": 48.8,
    className: "cls-1",
    transform: "translate(1833.377 2373)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "48.80"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_36.00_",
    "data-name": 36,
    className: "cls-1",
    transform: "translate(1906 2469.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "36.00 "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_43.00",
    "data-name": 43,
    className: "cls-1",
    transform: "translate(1821 3229)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "43.00"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_56.50",
    "data-name": 56.5,
    className: "cls-1",
    transform: "translate(2313.398 2773.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "56.50"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(2871.31 2773.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00-2",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(1913 3093)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_3_scooters_FRONT",
    "data-name": "TULU ride - 3 scooters FRONT",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "rotate(-90 3163.081 531.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "rotate(90 -208.552 2855.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-2",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-2",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-2",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-2",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(2792 3771.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-3",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-3",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M278.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-3",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-3",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "rotate(180 1726.398 1892.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-4",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-4",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M278.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-4",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-4",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_417",
    "data-name": "Line 417",
    className: "cls-2",
    transform: "translate(2613.377 3059.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_418",
    "data-name": "Line 418",
    className: "cls-2",
    transform: "translate(2668.21 3247.5)",
    d: "M109.667 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_421",
    "data-name": "Line 421",
    className: "cls-2",
    transform: "translate(2613.377 3700.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_422",
    "data-name": "Line 422",
    className: "cls-2",
    transform: "translate(2785.5 3709.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_434",
    "data-name": "Line 434",
    className: "cls-2",
    transform: "translate(3459.5 3709.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v452H0z",
    transform: "translate(2786 3248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(2786 3248)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h24v119H0z",
    transform: "translate(2799.615 3131.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(2799.615 3131.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h24v119H0z",
    transform: "translate(3435 3131.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(3435 3131.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2023",
    "data-name": "Rectangle 2023",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v452H0z",
    transform: "translate(3435 3248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(3435 3248)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26 0h607.385a26 26 0 0 1 26 26v49H0V26A26 26 0 0 1 26 0z",
    transform: "translate(2800 3060)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26 1.5h607.385a24.5 24.5 0 0 1 24.5 24.5v46a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 72V26A24.5 24.5 0 0 1 26 1.5z",
    transform: "translate(2800 3060)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2015",
    "data-name": "Rectangle 2015",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h615.797v48H0z",
    transform: "translate(2822 3651.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h612.797v45H1.5z",
    transform: "translate(2822 3651.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(2887.615 3657.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(2887.615 3657.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(2884 3242.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(2884 3242.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(3110 3243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(3110 3243)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(3337 3243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(3337 3243)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(3113 3658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(3113 3658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2021",
    "data-name": "Rectangle 2021",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(3340.115 3658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(3340.115 3658)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_423",
    "data-name": "Line 423",
    className: "cls-5",
    transform: "translate(2824.115 3688.333)",
    d: "M0 0h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_441",
    "data-name": "Line 441",
    className: "cls-5",
    transform: "translate(3373.797 3688.333)",
    d: "M0 0h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_424",
    "data-name": "Line 424",
    className: "cls-5",
    transform: "translate(2921.615 3688.333)",
    d: "M0 0h191.885"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_425",
    "data-name": "Line 425",
    className: "cls-5",
    transform: "translate(3147 3688.333)",
    d: "M0 0h193.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(2571.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(3127.071 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374-2",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h58.726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375-2",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h58.726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(2572 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_383",
    "data-name": "Line 383",
    className: "cls-5",
    transform: "translate(354 1433)",
    d: "M0 0h184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_384",
    "data-name": "Line 384",
    className: "cls-5",
    transform: "translate(354 1458)",
    d: "M0 0h184"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(2576 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_385",
    "data-name": "Line 385",
    className: "cls-5",
    transform: "translate(576 1433)",
    d: "M0 0h185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_386",
    "data-name": "Line 386",
    className: "cls-5",
    transform: "translate(576 1458)",
    d: "M0 0h185"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-5941.176 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-6168.324 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-6394.824 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 1457.881 1569.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 1570.881 1569.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    "data-name": "Path 4476",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 1683.881 1569.584)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_3_scooters_TOP",
    "data-name": "TULU ride - 3 scooters TOP",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "rotate(-90 3570.635 938.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-5",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-5",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M247.768 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-5",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-5",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "rotate(90 -657.024 3303.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-6",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-6",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M247.768 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-6",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-6",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_419",
    "data-name": "Line 419",
    className: "cls-2",
    transform: "translate(2686.5 4237.5)",
    d: "M127.376 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_420",
    "data-name": "Line 420",
    className: "cls-2",
    transform: "translate(2613.5 3958.5)",
    d: "M164.123 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_442",
    "data-name": "Line 442",
    className: "cls-2",
    transform: "translate(2613.5 4511.5)",
    d: "M256.123 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v245.571H0z",
    transform: "translate(2785.615 3958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(2785.615 3958)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2024",
    "data-name": "Rectangle 2024",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v245.571H0z",
    transform: "translate(3435 3958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(3435 3958)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_427",
    "data-name": "Line 427",
    className: "cls-4",
    transform: "translate(2822.115 3960)",
    d: "M0 0h614.385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_428",
    "data-name": "Line 428",
    className: "cls-5",
    transform: "translate(2822.115 4019)",
    d: "M0 0h609.514"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_429",
    "data-name": "Line 429",
    className: "cls-5",
    transform: "translate(2822.115 4105)",
    d: "M0 0h609.514"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(2353.615 2007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(2127.615 2007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246-2",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852-2",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242-2",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798-2",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248-2",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249-2",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241-2",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51-2",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008-2",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009-2",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010-2",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(1905.615 2008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246-3",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852-3",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242-3",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798-3",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248-3",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249-3",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241-3",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51-3",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008-3",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009-3",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010-3",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_431",
    "data-name": "Line 431",
    className: "cls-4",
    transform: "translate(3162.115 4237.5)",
    d: "M0 .238 153.385 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_432",
    "data-name": "Line 432",
    className: "cls-4",
    transform: "translate(2939.115 4237.571)",
    d: "M0 0h150.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    className: "cls-4",
    d: "M2800.5 493.25v37h47.25",
    transform: "translate(21.615 3707.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "rotate(-90 3814.112 423.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    className: "cls-4",
    d: "M0 0v47.962h41.292",
    transform: "translate(0 -2.448)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_side_view",
    "data-name": "TULU ride side view",
    transform: "translate(-780 -1013)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(3550 3771.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-7",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-7",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M90.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-7",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-7",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "rotate(180 1909.184 1892.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-8",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-8",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M95.868 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-8",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-8",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_433",
    "data-name": "Line 433",
    className: "cls-2",
    transform: "translate(3543.5 3709.667)",
    d: "M0 0v93.166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_439",
    "data-name": "Line 439",
    className: "cls-4",
    transform: "translate(3678.31 3251.077)",
    d: "M126.768 0H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_436",
    "data-name": "Line 436",
    className: "cls-4",
    transform: "translate(3543.5 3700.833)",
    d: "M126.768 0H0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_437",
    "data-name": "Line 437",
    className: "cls-4",
    transform: "translate(3543.5 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_440",
    "data-name": "Line 440",
    className: "cls-4",
    transform: "translate(3670.269 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    className: "cls-4",
    d: "M6577-3273.865h146.6c10.092 0 6.025-8.033 0-9.708s-138.274-17.194-138.274-17.194z",
    transform: "translate(-2906.5 6974.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_124",
    "data-name": "Union 124",
    className: "cls-7"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.061 232.308 12.048-42.022L0 3.925 9.243 0l80.793 190.329-.559.237-12.763 44.512z",
    transform: "translate(3591.033 3059.815)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.657 231.367 11.909-41.535L7.654 3.934l-3.72 1.58 78.352 184.578-11.514 40.16 3.885 1.115m2.057 3.711-9.653-2.77 12.048-42.021L0 3.925 9.243 0l80.793 190.329-.56.237-12.762 44.512z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(3591.033 3059.815)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line_438",
    "data-name": "Line 438",
    className: "cls-2",
    transform: "translate(3823.5 3709.667)",
    d: "M0 0v93.166"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallscooterstand);
export default __webpack_public_path__ + "static/media/small scooter stand.7d8e309d52ea7233243b55f4ac37adbc.svg";
export { ForwardRef as ReactComponent };